<!-- Probably legacy component: imported nowhere (2026-10-11); Table.vue uses TableRows.vue.
     Left in place. -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <tr v-for="(event, eventIndex) in renderedEvents" :key="eventIndex">
    <td v-if="event.type === 'session'" colspan="3"><b v-html="normalizedTitle(event)" /><br /></td>

    <td v-if="event.type !== 'session'">
      {{ formatTime(event.start) }}
      <span v-if="event.end" class="wideScreenOnly"> - {{ formatTime(event.end) }} </span>
    </td>

    <td v-if="event.type !== 'session'">
      <VideoIcon :event="event" />
    </td>

    <td v-if="event.type !== 'session'">
      <span class="event">
        <span v-if="!description" class="arrows" @click="toggleDescription(event.ref)">
          <span
            v-if="event.description && !isTitleLinked(event)"
            :ref="setRef(event.ref + 'RightArrow')"
            class="right chevronArrow" />
          <span
            v-if="event.description && !isTitleLinked(event)"
            :ref="setRef(event.ref + 'DownArrow')"
            class="hide down chevronArrow" />
        </span>

        <span class="eventTitle">
          <span v-if="event.type === 'keynote'"><b>Keynote: </b></span>
          <span v-html="normalizedTitle(event)" />

          <!-- SPEAKERS -->
          <template v-if="hasJointSpeakers(event)">
            (<span v-html="speakerLinksHtml(event)" />)
          </template>

          <template v-else-if="normalizedName(event)">
            (<a :href="speakerUrl(normalizedName(event))"> {{ normalizedName(event) }} </a>)
          </template>

          <Slides
            v-if="normalizedName(event) && !hasJointSpeakers(event)"
            :name="normalizedName(event)"
            align="left" />

          <p
            v-if="event.description && !isTitleLinked(event)"
            :ref="setRef(event.ref)"
            :class="{hide: !description, description: true}"
            v-html="event.description" />
        </span>
      </span>
    </td>
  </tr>
</template>

<script setup>
const props = defineProps(["programDay", "description", "timeZoneSelected"]);

import Slides from "@/components/People/Person/Slides";
import VideoIcon from "@/components/Program/VideoIcon";
import {reactive, computed} from "vue";

/* ---------- refs ---------- */

const refs = reactive({});

function setRef(key) {
  return (el) => el && (refs[key] = el);
}

function toggleDescription(refKey) {
  const el = refs[refKey];
  const r = refs[`${refKey}RightArrow`];
  const d = refs[`${refKey}DownArrow`];
  if (!el) return;
  el.classList.toggle("hide");
  r.classList.toggle("hide");
  d.classList.toggle("hide");
}

/* ---------- year ---------- */

const meetingYear = computed(() => {
  const text = String(props?.programDay?.date || "");
  const match = text.match(/(\d{4})$/);
  return match ? match[1] : "";
});

/* ---------- normalization ---------- */


function normalizedName(event) {
  return event?.name || "";
}

function normalizedTitle(event) {
  return event?.title || "";
}

/* ---------- speaker URLs ---------- */

function slugifyName(name) {
  return String(name || "")
    .trim()
    .replace(/\s+/g, "_");
}

function speakerUrl(name) {
  if (!name || !meetingYear.value) return "";
  return `/${meetingYear.value}/People#${slugifyName(name)}`;
}

/* ---------- joint speakers ---------- */

function hasJointSpeakers(event) {
  return Array.isArray(event?.speakers) && event.speakers.length > 1;
}

function speakerLinksHtml(event) {
  return event.speakers
    .map((s) => {
      const url = speakerUrl(s.name);
      return `<a href="${url}">${s.name}</a>`;
    })
    .join(" &amp; ");
}

/* ---------- merging ---------- */

function sameTime(a, b) {
  return (
    a?.start?.toMillis?.() === b?.start?.toMillis?.() &&
    a?.end?.toMillis?.() === b?.end?.toMillis?.()
  );
}

function mergeEvents(events) {
  const out = [];
  for (let i = 0; i < events.length; i++) {
    const a = events[i];
    const b = events[i + 1];
    if (b && a.type === b.type && sameTime(a, b) && a.title === b.title) {
      out.push({
        ...a,
        name: `${a.name} & ${b.name}`,
        speakers: [{name: a.name}, {name: b.name}]
      });
      i++;
    } else {
      out.push(a);
    }
  }
  return out;
}

const renderedEvents = computed(() => mergeEvents(props?.programDay?.events || []));

/* ---------- rendering rules ---------- */

function isTitleLinked(event) {
  const title = String(event?.title || "").trim();
  return title.startsWith("<a ") && title.endsWith("</a>");
}

/* ---------- time ---------- */

function formatTime(date) {
  if (!date || !props.timeZoneSelected) return "";
  return date.toFormat("h:mma").toLowerCase();
}
</script>
